import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';


import { COLUMNS } from '../config/Transaction/columns';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';

interface AsyncState {
  isLoading: {
    tagsData: boolean;
    deleteTags: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  tagsData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addOfferRes: any;
  editProductRes: any;
  deleteTags: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any,

}

const initialState: TableState = {
  isLoading: {
    tagsData: true,
    deleteTags: false,
  },
  isSuccess: false,
  isError: false,
  tagsData: null,
  statusData: null,
  applicationOptions: null,
  addOfferRes: {},
  editProductRes: null,
  deleteTags: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};




export const fetchAllTags = createAsyncThunk('tagsData', async (data: any, thunkAPI) => {
  try {
    const res: any = await Service.getAllTags();

    const madeData = makeData(res.data);

    return { madeData, totalCount: res.totalCounts, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});


// export const addOffer = createAsyncThunk('user/addBrandData', async (data: any, thunkAPI) => {
//   try {
//     return await Service.addOffer(data);
//   } catch (error) {
//     // thunkAPI.dispatch(resetLogout(error));
//     return thunkAPI.rejectWithValue(error);
//   }
// });

export const deleteTags = createAsyncThunk('user/deleteTags', async (data: any, thunkAPI) => {
  try {
    return await Service.deleteTags(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const getColumns = createAsyncThunk('getColumns', (data: any, thunkAPI) => {
  try {
    // const madeColsData = makeData(data);
    return data?.cols;
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    resetAddOfferRes: (state) => {
      state.addOfferRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllTags.pending, (state, action: any) => {
        state.isLoading.tagsData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllTags.fulfilled, (state, action: any) => {
        state.isLoading.tagsData = false;
        state.isSuccess = true;
        state.isError = false;
        state.tagsData = action.payload.madeData;
        state.totalCount = action.payload.totalCount;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllTags.rejected, (state, action: any) => {
        state.isLoading.tagsData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload
        }

      })

      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(deleteTags.pending, (state) => {
        state.isLoading.deleteTags = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteTags = null;
      })
      .addCase(deleteTags.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Tag Deleted successfully', "success");
        state.isLoading.deleteTags = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteTags = action.payload;
      })
      .addCase(deleteTags.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteTags = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteTags = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});
export const { resetAddOfferRes } = tagsSlice.actions;
export default tagsSlice.reducer;
